import {Deserializable} from "./deserializable.model";

export class SubjectBillingItem {

  subject_billing_item_id?: number;
  billing_task_name?: string;
  myob_tax_code_id?: number;
  myob_account_code_id?: number;
  billing_task_description?: string;
  billing_task_fee?: number;
  billing_task_id?: number;
  subject_id: number;
  subject_number?: number;
  job_id: number;
  job_number?: number;
  invoice_status?: string;
  brand_id?: number;
  // new
  qty?: number; // do this later down the track...

  // Need to create the missing invoice items details so that I can push back to the invoice once removed/deleted or updated
  // Feb 2023
  unit_price?: number;
  tax?: number;
  total?: number
  is_bulk?;

  app_route_id?;

  // ? what does this really do? (no encoding or deserialisation required...)
  // deserialize(input: any): SubjectBillingItem {
  //   Object.assign(this, input);

  //   return this;
  // }

  /*
subject_billing_item_id
billing_task_name
myob_tax_code_id
myob_account_code_id
billing_task_description
billing_task_fee
billing_task_id
subject_id
subject_number
job_id
job_number
  */


}


/*
// Feb 2023 Additions so that the real memerory of items are updated and saved from teh invoice qtyies and taxes etc... and then pushed back.

    "invoice_number": "1168.1",
    "billing_task_id": "5",
    "subject_billing_item_id": "301",
    "billing_task_name": "1168.1.1.1 - Field Call Fee - Editoed",
    "myob_tax_code_id": "1",
    "myob_account_code_id": "16",
    "billing_task_fee": "0.00",
    "billing_task_description": "",
    "subject_id": "605",
    "subject_number": "1168.1.1.1",
    "job_id": "1168",
    "job_number": "1168.1",
    "qty": 1,
    "unit_price": "0.00",
    "tax": 0,
    "total": 0

*/